// @flow

import * as React from 'react';
import BoardCreate from 'app/common/react/components/BoardCreate/BoardCreate';
import i18n from 'app/common/lib/i18n';
import LayerModal from 'app/common/react/ui/Modal';
import type { BoardPrivacy, ProfileBoard } from 'app/packages/pinterest-flow-types/board';
import withResource, { type Resource } from 'app/common/lib/react/withResource';
import { Spinner, Modal as GestaltModal } from 'gestalt';

type Props = {|
  categoriesResource: Resource<Array<{ key: string, name: string }>>,
  onBoardCreate: (board: ProfileBoard) => void,
  onClose: () => void,
  privacy?: BoardPrivacy,
  suggestedBoardName?: string,
  useLayer?: boolean,
|};

export function BoardCreateModal(props: Props) {
  const {
    categoriesResource: { data, isLoaded },
    onBoardCreate,
    onClose,
    privacy,
    suggestedBoardName,
    useLayer = true,
  } = props;
  const Modal = useLayer ? LayerModal : GestaltModal;
  return (
    <Modal
      accessibilityCloseLabel={i18n._(
        'Cancel',
        'accessibility label for canceling create board modal',
      )}
      accessibilityModalLabel={i18n._('Create', 'accessibility label for create board modal')}
      heading={i18n._('Create board', 'header for create board modal')}
      onDismiss={onClose}
      size="md"
    >
      {isLoaded && data ? (
        <BoardCreate
          categories={data}
          onBoardCreate={onBoardCreate}
          onClose={onClose}
          privacy={privacy}
          suggestedBoardName={suggestedBoardName}
          noHeader
        />
      ) : (
        <Spinner
          accessibilityLabel={i18n._(
            'Create a board',
            'Spinner while the create board modal is loading',
          )}
          show
        />
      )}
    </Modal>
  );
}

export default withResource(
  {
    name: 'CategoriesResource',
    key: 'categoriesResource',
  },
  { allowstate: false },
)(BoardCreateModal);
